<template>
    <b-card class="mb-0" v-b-visible="mountedAction">
        <template v-slot:header>
            <span class="h6"><i class="fa-duotone fa-money-bill-trend-up mr-1"></i> Profit Report</span>
        </template>
        <b-row class="mb-2">
            <b-col>
                <b-form-radio-group buttons button-variant="outline-dark" size="sm" :options="reportRangeOptions"
                                    v-model="reportRange"></b-form-radio-group>
            </b-col>
            <b-col class="text-right">
                <b-form-radio-group buttons button-variant="outline-primary" size="sm" :options="bullionOptions"
                                    v-model="bullion"></b-form-radio-group>
            </b-col>
        </b-row>
        <b-table
                show-empty
                striped
                hover
                class="orders-dropdown-table"
                head-variant="dark"
                foot-variant="dark"
                foot-clone
                small
                :items="values"
                :busy.sync="loading"
        >
            <template v-slot:table-busy>
                <LoadingSpinner :busy="loading" heavy-data-load/>
            </template>
            <template v-slot:cell(received_value)="data">
                {{ data.value | currency }}
            </template>
            <template v-slot:cell(avg_received_value)="data">
                {{ data.value | currency }}
            </template>
            <template v-slot:cell(retained_value)="data">
                {{ data.value | currency }}
            </template>
            <template v-slot:cell(retained_rate)="data">
                {{ data.value }}%
            </template>
            <template v-slot:cell(customer_paid)="data">
                {{ data.value | currency }}
            </template>
            <template v-slot:cell(gross_revenue)="data">
                {{ data.value | currency }}
            </template>
            <template v-slot:cell(customer_paid_rate)="data">
                {{ data.value }}%
            </template>
            <template v-slot:cell(GP_Per_Received_Dollar)="data">
                {{ data.value | currency }}
            </template>
            <template v-slot:cell(Initial_Offer_Acceptance_Rate)="data">
                {{ data.value }}%
            </template>

            <template #foot(date_received)="data">
                <strong><i>Total:</i></strong>
            </template>
            <template #foot(month_received)="data">
                <strong><i>Total:</i></strong>
            </template>
            <template #foot()="data">
                <i>{{ totals[data.field.key] }}</i>
            </template>
            <template #foot(received_value)="data">
                {{ totals[data.field.key] | currency }}
            </template>
            <template #foot(avg_received_value)="data">
                {{ totals[data.field.key] | currency }}
            </template>
            <template #foot(retained_value)="data">
                {{ totals[data.field.key] | currency }}
            </template>
            <template #foot(retained_rate)="data">
                {{ totals[data.field.key] }}%
            </template>
            <template #foot(customer_paid)="data">
                {{ totals[data.field.key] | currency }}
            </template>
            <template #foot(gross_revenue)="data">
                {{ totals[data.field.key] | currency }}
            </template>
            <template #foot(customer_paid_rate)="data">
                {{ totals[data.field.key] }}%
            </template>
            <template #foot(GP_Per_Received_Dollar)="data">
                {{ totals[data.field.key] | currency }}
            </template>
            <template #foot(Initial_Offer_Acceptance_Rate)="data">
                {{ totals[data.field.key] }}%
            </template>

        </b-table>
    </b-card>
</template>

<script>
    import _ from 'lodash';
    import LoadingSpinner from '../../../components/LoadingSpinner';
    export default {
        components: {LoadingSpinner,},
        name: 'ProfitReport',
        expandGraphs: false,
        props: {

        },
        data() {
            return {
                expandGraphs: false,
                datePickerProps: {
                    placement: 'bottom',
                },
                modelConfig: {
                    start: {
                        timeAdjust: '00:00:00',
                    },
                    end: {
                        timeAdjust: '23:59:59',
                    },
                },
                bullion: null,
                bullionOptions: [{value: null, text: 'All'}, {value: 1, text: 'Bullion'}, {value: 0, text: 'Non-Bullion'}, ],
                reportRange: '30-days',
                reportRangeOptions: ['30-days', '6-months',],
                dateRange: {
                    start: null,
                    end: null
                },
                fields: [
                    'Orders',
                    'Avg_Received_Value',
                    'Received_Value',
                    'Offer_Accepted',
                    'Retained_Value',
                    'Retained_Rate',
                    'Customer_Paid',
                    'Gross_Revenue',
                    'Customer_Paid_Rate',
                    'GP_Per_Received_Dollar',
                    'Initial_Offer_Acceptance_Rate',
                ],
                loading: false,
                values: null,
                totals: null,
            };
        },
        beforeDestroy(){
        },
        created() {
            this.getData();
        },
        methods: {
            getData() {
                let data = {
                    'report_range': this.reportRange,
                    'bullion': this.bullion
                };
                this.values = null;
                this.loading = true;
                this.$http.post('/dashboards/ProfitReport/' , data).then((data) => {
                    this.values = data.data.data.values;
                    this.totals = data.data.data.totals;
                    // _.forEach(data.data.data.values, (value) => {
                    //     this.values.push(value);
                    // });
                    this.loading = false;
                });
            },
            mountedAction() {

            },
            expandGraph() {
                this.expandGraphs = this.expandGraphs;
            },
        },
        updateSearch(event) {
            if (event) {
                event.preventDefault();
            }
            this.getData();
        },
        watch: {
            bullion: function(val) {
                this.getData();
            },
            reportRange: function(val) {
                this.getData();
            }
        }
    };

</script>


<style scoped>
    .merge-card {
        flex: 1;
        margin:0 1.5%;
    }

    .data {
        flex: 1;
        border-bottom: 1px solid #f4f4f4;
        margin-bottom: 2px
    }
    .data__title {
        font-weight: 400;
    }
    .data__num {
        float: right;
    }

    .display_on_top {
        z-index: 1000;
    }

    .card {
        flex: 1;
        /*margin: 0 8px;*/
        transition: .3s ease-in-out;
    }

    .card.expand-graph {
        flex: 5 !important;
    }
    .font-uppercase {
        text-transform: uppercase;
    }

    >>> label {
        font-size: 0.65rem !important;
        /*text-transform: unset !important;*/
    }
</style>